module.exports = "<div class=\"welcome\">\r\n  <img src=\"/assets/logo.png\" class=\"zonifero-services-logo\" title=\"Zonifero Services logo\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/WelcomeComponent/welcome.component.html
// module id = ./src/app/common/components/WelcomeComponent/welcome.component.html
// module chunks = main